import React from 'react'
import { Dropdown } from 'primereact/dropdown'

const AV_TYPE_OPTIONS = [
    { label: 'Empty', value: '__EMPTY__' },
    { label: 'Radio', value: 'Radio' },
    { label: 'TV', value: 'TV' }
]

/**
 * AV Type filter template with dropdown for Radio/TV selection
 * @param {object} options - Filter options from PrimeReact column
 */
const AvTypeFilterTemplate = ({ options }) => {
    return (
        <Dropdown
            value={options.value}
            options={AV_TYPE_OPTIONS}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select AV Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default AvTypeFilterTemplate
